import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import SliderAdapter from 'components/atoms/slider-adapter';

class FilterSlider extends Component {
    handleSliderChange(values) {
        this.props.dispatch(
            Action.set('InnerProjectedOwnershipCap', {
                min: parseInt(values[0]),
                max: parseInt(values[1]),
            }),
        );
    }

    render() {
        const {projectedOwnershipCap, step = 100} = this.props;

        const defaultMin = projectedOwnershipCap.getInnerCapBoundary('min');
        const defaultMax = projectedOwnershipCap.getInnerCapBoundary('max');
        const min = projectedOwnershipCap.getOuterMin();
        const max = projectedOwnershipCap.getOuterMax();

        return (
            <SliderAdapter
                key={`slider-${defaultMin}-${defaultMax}`}
                onChange={::this.handleSliderChange}
                min={min}
                max={max}
                defaultValue={[defaultMin, defaultMax]}
                thumb={<div className="circle shifted"></div>}
                minDistance={step}
                step={step}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {projectedOwnershipCap} = state;

    return {
        projectedOwnershipCap,
    };
}

export default connect(mapStatesToProps)(FilterSlider);
